import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectDomain = (state: RootState) => state.music || initialState

export const selectMusic = createSelector([selectDomain], music => music)
